import Highcharts from 'highcharts';

import { InsightsChartSpec } from 'services/streamInsightsQuery';

import buildCartesianOptions from './chartOptions/cartesianOptions';
import buildCrosstabOptions from './chartOptions/crosstabOptions';
import buildPolarOptions from './chartOptions/polarOptions';
import buildSliceOptions from './chartOptions/sliceOptions';
import buildWaterfallOptions from './chartOptions/waterfallOptions';
import buildXyOptions from './chartOptions/xyOptions';

// Re-exported from their new home so existing importers (InsightsMessageChart)
// keep working.
export { formatChartValue, INSIGHTS_CHART_HEIGHT } from './chartOptions/shared';

// Map a streamed InsightsChartSpec to a self-contained Highcharts config. No
// metric cache / vis-def pipeline needed — the spec already carries the resolved
// categories + numeric series.
//
// This deliberately does NOT reuse src/components/V5Gadget/highchartOptions/*:
// those builders take a `formatMetric` (needs the metric cache), an `openMenu`
// (needs DashboardContextMenuContext) and a live V5ChartDefinition, none of
// which exist in the chat. Each family below is a standalone mirror instead.
const buildChartOptions = (spec: InsightsChartSpec): Highcharts.Options => {
  switch (spec.chartType) {
    case 'pie':
    case 'donut':
    case 'funnel':
    case 'pyramid':
    case 'packedBubble':
      return buildSliceOptions(spec);
    case 'radar':
      return buildPolarOptions(spec);
    case 'waterfall':
      return buildWaterfallOptions(spec);
    case 'scatter':
    case 'bubble':
      return buildXyOptions(spec);
    case 'heatmap':
    case 'sankey':
      return buildCrosstabOptions(spec);
    case 'bar':
    case 'column':
    case 'line':
    case 'area':
    default:
      return buildCartesianOptions(spec);
  }
};

export default buildChartOptions;
